export default {
  FIELD_ITEM: 'FIELD',
  STEP_ITEM: 'STEP',
};
